import axios from 'axios';

/**
 * Extract a human-readable error message from any thrown value — handles
 * axios errors (server response shapes), plain Error, and unknown types.
 */
export function extractErrorMessage(
  err: unknown,
  fallback = 'Something went wrong'
): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as
      | { message?: unknown; details?: unknown; error?: unknown }
      | undefined;
    if (data?.message && typeof data.message === 'string') return data.message;
    if (data?.details && typeof data.details === 'string') return data.details;
    if (data?.error && typeof data.error === 'string') return data.error;
    if (err.message) return err.message;
  }
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  return fallback;
}
